// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__4KW2-","card":"styles_card__1BuKK","header":"styles_header__bCbfg"};